"use client";
import * as React from "react";
const SvgPlayCircleOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 720 800", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m303 570 267-170-267-170v340zm97 230q-82 0-155-31.5t-127.5-86Q63 628 31.5 555T0 400q0-83 31.5-156t86-127Q172 63 245 31.5T400 0q83 0 156 31.5T683 117q54 54 85.5 127T800 400q0 82-31.5 155T683 682.5q-54 54.5-127 86T400 800zm0-60q142 0 241-99.5T740 400q0-142-99-241T400 60q-141 0-240.5 99T60 400q0 141 99.5 240.5T400 740zm0-340z" }));
export {
  SvgPlayCircleOutlined as default
};
